import styled, { css } from 'styled-components';
import { borderRadius, mediaQuery, nativeTabbarSpacePadding, paddings, zModal } from '~/styled';

export const ModalTitle = styled.div`
  padding: 20px 24px 12px;
  color: ${({ theme }) => theme.colors.onSurface};
  display: flex;
  flex-direction: row;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  background: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};
  word-break: break-word;
  border-radius: ${borderRadius.default} ${borderRadius.default} 0 0;
  ${mediaQuery.down.s`
    position: sticky;
    top:0;
    z-index: ${zModal};
  `}
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${() => zModal};
`;

export const IconSpan = styled.span`
  margin-right: 16px;
  line-height: 24px;
  display: inline-block;
`;

export const ModalOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(32, 30, 30, 0.2);
  transition: background 0.3s linear;
`;

export const CloseIcon = styled.div`
  float: right;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const ModalContent = styled.div<{ $classAttrbutes?: string }>`
  position: absolute;
  background: ${({ theme }) => theme.colors.surface};
  -webkit-overflow-scrolling: touch;
  outline: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  max-width: 90%;
  max-height: 100%;
  min-width: 400px;
  ${({ $classAttrbutes }) =>
    $classAttrbutes &&
    css`
      ${$classAttrbutes}
    `}

  ${mediaQuery.down.s`
      min-width:unset;
      max-width: unset;
      width:100%;
      height:100%;
      border-radius: 0;
      overflow-y: auto;
      ${nativeTabbarSpacePadding}
    `}

    &.delete-and-confirmation-modal {
    width: calc(100% - ${paddings.hugePadding});
    height: auto;
    border-radius: ${borderRadius.default};
    ${mediaQuery.up.xl`
      min-width: 580px;
    `}
    ${mediaQuery.between('l', 'xl')`
       min-width: 670px;
    `}
    ${mediaQuery.up.s`
      width:30%;
    `}
  }
`;

export const BodyContent = styled.div<{ $fadeOut?: boolean }>`
  padding: 24px 24px;
  ${mediaQuery.down.s`
    padding:${paddings.medium2xPadding};
    height: 100%;
  `}
  opacity: ${({ $fadeOut }) => ($fadeOut ? 0.5 : 1)};
`;

export const BaseBodyContent = css`
  padding: 24px 24px;
  ${mediaQuery.down.s`
    padding:20px
  `}
`;

export const FooterContent = styled.div`
  padding: 8px 24px 24px;
  text-align: right;

  button:not(:first-of-type) {
    margin-left: 16px;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(32, 30, 30, 0.2);
  transition: background 0.3s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${zModal};
  & * {
    box-sizing: border-box;
  }
`;

export const MobileBackBtnDiv = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

export const ModalContentDiv = styled.div<{
  $infoOrErrorOrWarning?: boolean;
  $hasFooter?: boolean;
}>`
  flex-grow: 1;
  ${mediaQuery.up.s`
    max-height: calc(100% - 80px - 55px);
    overflow-y: auto;
  `}
  ${mediaQuery.down.s`
    overflow-y: auto;
  `}
  ${({ $infoOrErrorOrWarning, $hasFooter }) =>
    !$infoOrErrorOrWarning &&
    !$hasFooter &&
    mediaQuery.down.s`
      ${nativeTabbarSpacePadding}
    `}
  ${({ $infoOrErrorOrWarning }) =>
    $infoOrErrorOrWarning &&
    css`
      width: 100%;
    `}
`;

export const InModalMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  &:last-child {
    display: none;
  }
`;
